export enum Templates {
  welcomePhone = './conta-validada-morador',
  changePhasePhone = './troca-fase-morador',
  moradorMessage = './contact-message-morador',
}
